import React, { useEffect } from "react"
import styles from "@/components/GlobalVisualSearch/GlobalVSContent/index.module.scss"
import closeIcon from "@/public/icons/close-icon-black.svg"
import {
  Box,
  Button,
  Flex,
  Tooltip,
  Typography,
} from "@kohler-dsm-library/kohler-core"
import { addAdobeDataLayerGlobalVisualSearch } from "@/components/GlobalVisualSearch/analytics"
import { getTranslations } from "@/components/GlobalVisualSearch/localization"
import { useTranslation } from "next-i18next"
import { GlobalVisualSearchIcon } from "@/components/GlobalVisualSearch/GlobalVSContent/icons"

const GlobalVSContent = props => {
  const {
    setOpenVisualSearch,
    className = "",
    isFirstTime,
    setIsFirstTime = () => {},
    onClickHandler = () => {},
  } = props || {}
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)
  const {
    newSearchTitle = "",
    photoSelectLibrary = "",
    gotIt = "",
    searchImageText = "",
  } = staticText

  useEffect(() => {
    if (typeof window !== "undefined") {
      const storedValue = localStorage.getItem("usingVSforFirstTime")

      if (storedValue === null) {
        localStorage.setItem("usingVSforFirstTime", "true")
        setIsFirstTime(true)
      } else {
        setIsFirstTime(storedValue === "true")
      }
    }
  }, [])

  useEffect(() => {
    const handleGlobalClick = () => {
      const hasSeenTooltip = localStorage.getItem("usingVSforFirstTime")

      if (hasSeenTooltip === "true") {
        localStorage.setItem("usingVSforFirstTime", "false")
        setIsFirstTime(false)
      }
    }

    document.body.addEventListener("click", handleGlobalClick)

    return () => {
      document.body.removeEventListener("click", handleGlobalClick)
    }
  }, [isFirstTime])

  const handleGotItClick = () => {
    localStorage.setItem("usingVSforFirstTime", "false")
    setIsFirstTime(false)
  }

  const handleIconClick = () => {
    if (!isFirstTime) {
      setOpenVisualSearch(true)
      onClickHandler && onClickHandler()
      addAdobeDataLayerGlobalVisualSearch({
        event: "search_icon_click",
      })
    }
  }

  const renderVSIcon = () => {
    return (
      <button onClick={handleIconClick}>
        <GlobalVisualSearchIcon />
      </button>
    )
  }

  return (
    <div
      className={`${styles.GlobalVisualSearchContainer} ${className} ${
        isFirstTime && "firstTime_shadow"
      }`}
    >
      <Box>
        {isFirstTime ? (
          <>
            <Box
              className={`${styles.firstTimeVSContainer} ${
                isFirstTime && "firstTimeIcon_shadow"
              }`}
            >
              {renderVSIcon()}
              <Flex
                align={"start"}
                justify={"space-between"}
                direction={"column"}
                gap={"15px"}
                className={styles.tooltipBoxNew}
              >
                <div className={styles.tooltipBoxCont}>
                  <div className={styles.tooltipBoxContHead}>
                    <Typography size={"label-medium-l"}>
                      {newSearchTitle}
                    </Typography>
                    <Typography size={"paragraph-l"}>
                      {photoSelectLibrary}
                    </Typography>
                  </div>
                  <div className={styles.tooltipBoxCloseIcon}>
                    <img
                      onClick={handleGotItClick}
                      src={closeIcon.src}
                      alt="close"
                      aria-hidden
                    />
                  </div>
                </div>
                <div className="pr-5 pb-5">
                  <Button
                    size="small"
                    fullWidth={true}
                    variant="secondary"
                    onClick={handleGotItClick}
                  >
                    {gotIt}
                  </Button>
                </div>
              </Flex>
            </Box>
          </>
        ) : (
          <Tooltip
            label={
              <Typography size={"paragraph-l"}>{searchImageText}</Typography>
            }
            offset={20}
            position="bottom"
            className="visualSearchTooltip"
            mod="white"
          >
            {renderVSIcon()}
          </Tooltip>
        )}
      </Box>
    </div>
  )
}

export default GlobalVSContent
